import styles from './homeHead.module.scss'
import { Text } from 'typography/text'
import { PageHeader } from 'sections/pageHeader/pageHeader'

export const HomeHead = () => {
  return (
    <PageHeader full>
      <div className={styles.homeHead__banner}>
        <div className={styles.homeHead__bannerContent}>
          <h2 className={`h3 ${styles.homeHead__bannerTitle}`}>Discount Air Travel Made Simple!</h2>
          <Text className={styles.homeHead__bannerText}>
            <p>FREE trip-planning and personalized assistance available 24/7</p>
          </Text>
        </div>
      </div>
    </PageHeader>
  )
}
